import ShowPost from 'modules/posts/components/ShowPost'

const ShowPostPage = () => {
  return <ShowPost />
}

export default ShowPostPage
